// Column configurations for the config-driven Finans tabs (FinansDataTable).
// Each column: { key, title, type, entity?, entityFilter?, display?, options?, required?, inTable?, inForm?, width?, defaultValue?, max? }

const ACTIVE_OPTS = [{ value: 1, label: 'Aktif' }, { value: 0, label: 'Pasif' }];
const EVET_HAYIR = [{ value: 1, label: 'Evet' }, { value: 0, label: 'Hayır' }];

const odemeFilter = (i) => Number(i.odeme) === 1;
const tahsilatFilter = (i) => Number(i.odeme) === 0;

const cariCol = { key: 'cari_id', title: 'Cari', type: 'entity', entity: 'cari', display: 'cari_ad', required: true, width: 170 };
const firmaCol = { key: 'firma_id', title: 'Firma', type: 'entity', entity: 'firma', display: 'firma_adi', required: true, width: 150 };
const tutarCol = { key: 'tutar', title: 'Tutar', type: 'amount', required: true, width: 130 };
const dovizCol = { key: 'doviz', title: 'Döviz', type: 'doviz', defaultValue: 'TRY', inTable: false };
const aciklamaCol = { key: 'aciklama', title: 'Açıklama', type: 'textarea', width: 200 };

export const paymentColumns = [
  { key: 'tarih', title: 'Tarih', type: 'date', required: true, width: 110 },
  cariCol, firmaCol, tutarCol,
  { key: 'islem_turu_id', title: 'İşlem Türü', type: 'entity', entity: 'islem_turu', entityFilter: odemeFilter, display: 'islem_turu_ad', required: true, width: 160 },
  dovizCol,
  { key: 'banka_hesap_id', title: 'Banka Hesabı', type: 'entity', entity: 'hesaplar', display: 'banka_hesap_adi', width: 170 },
  aciklamaCol,
];

export const collectionColumns = [
  { key: 'tarih', title: 'Tarih', type: 'date', required: true, width: 110 },
  cariCol, firmaCol, tutarCol,
  { key: 'islem_turu_id', title: 'İşlem Türü', type: 'entity', entity: 'islem_turu', entityFilter: tahsilatFilter, display: 'islem_turu_ad', required: true, width: 160 },
  dovizCol,
  { key: 'banka_hesap_id', title: 'Banka Hesabı', type: 'entity', entity: 'hesaplar', display: 'banka_hesap_adi', width: 170 },
  aciklamaCol,
];

export const recurringColumns = [
  { key: 'tarih', title: 'Tarih', type: 'date', required: true, width: 110 },
  { key: 'vade', title: 'Vade', type: 'date', required: true, width: 110 },
  cariCol, firmaCol, tutarCol,
  { key: 'islem_turu_id', title: 'İşlem Türü', type: 'entity', entity: 'islem_turu', entityFilter: odemeFilter, display: 'islem_turu_ad', required: true, width: 160 },
  dovizCol,
  {
    key: 'tekrar_sikligi', title: 'Tekrar', type: 'select', width: 110, defaultValue: 'Aylık',
    options: ['Haftalık', 'Aylık', 'Yıllık', 'Özel'].map((v) => ({ value: v, label: v })),
  },
  { key: 'aktif', title: 'Aktif', type: 'select', options: EVET_HAYIR, defaultValue: 1, width: 90 },
  aciklamaCol,
];

export const paymentRequestColumns = [
  { key: 'tarih', title: 'Tarih', type: 'date', required: true, width: 110 },
  { key: 'vade', title: 'Vade', type: 'date', required: true, width: 110 },
  cariCol, firmaCol, tutarCol,
  { key: 'islem_turu_id', title: 'İşlem Türü', type: 'entity', entity: 'islem_turu', entityFilter: odemeFilter, display: 'islem_turu_ad', required: true, width: 160 },
  dovizCol,
  { key: 'iban', title: 'IBAN', type: 'text', width: 200, inTable: false },
  { key: 'talep_eden', title: 'Talep Eden', type: 'text', required: true, width: 130 },
  aciklamaCol,
];

export const cariColumns = [
  { key: 'ad', title: 'Ad', type: 'text', required: true, width: 200 },
  {
    key: 'tip', title: 'Tip', type: 'select', width: 120,
    options: ['Müşteri', 'Tedarikçi', 'Personel', 'Diğer'].map((v) => ({ value: v, label: v })),
  },
  { key: 'firma_id', title: 'Firma', type: 'entity', entity: 'firma', display: 'firma_adi', width: 150 },
  { key: 'kod', title: 'Kod', type: 'text', width: 100 },
  { key: 'telefon', title: 'Telefon', type: 'text', width: 120 },
  { key: 'email', title: 'E-posta', type: 'text', width: 160 },
  { key: 'vergi_no', title: 'Vergi No', type: 'text', width: 120 },
  { key: 'vergi_dairesi', title: 'Vergi Dairesi', type: 'text', width: 140, inTable: false },
  { key: 'iban', title: 'IBAN', type: 'text', width: 220, max: 32 },
  { key: 'yetkili', title: 'Yetkili', type: 'text', width: 130, inTable: false },
  { key: 'adres', title: 'Adres', type: 'textarea', inForm: true, inTable: false },
  { key: 'notlar', title: 'Notlar', type: 'textarea', inForm: true, inTable: false },
  { key: 'active', title: 'Durum', type: 'select', options: ACTIVE_OPTS, defaultValue: 1, width: 90 },
];

export const transactionTypeColumns = [
  { key: 'kod', title: 'Kod', type: 'text', required: true, width: 90, max: 10 },
  { key: 'ad', title: 'Ad', type: 'text', required: true, width: 220 },
  { key: 'odeme', title: 'Tip', type: 'select', width: 120, defaultValue: 1, options: [{ value: 1, label: 'Ödeme' }, { value: 0, label: 'Tahsilat' }] },
  { key: 'iban_required', title: 'IBAN Zorunlu', type: 'select', width: 120, defaultValue: 0, options: EVET_HAYIR },
  { key: 'aciklama', title: 'Açıklama', type: 'textarea', width: 220 },
  { key: 'active', title: 'Durum', type: 'select', options: ACTIVE_OPTS, defaultValue: 1, width: 90 },
];

export const companyColumns = [
  { key: 'firma_adi', title: 'Firma Adı', type: 'text', required: true, width: 180, max: 30 },
  { key: 'unvan', title: 'Ünvan', type: 'text', width: 220 },
  { key: 'tel', title: 'Telefon', type: 'text', width: 130 },
  { key: 'mail', title: 'E-posta', type: 'text', width: 160 },
  { key: 'vergiDairesi', title: 'Vergi Dairesi', type: 'text', width: 140, inTable: false },
  { key: 'vergiNo', title: 'Vergi No', type: 'text', width: 120 },
  { key: 'adres', title: 'Adres', type: 'textarea', inTable: false },
  { key: 'active', title: 'Durum', type: 'select', options: ACTIVE_OPTS, defaultValue: 1, width: 90 },
];

export const accountColumns = [
  { key: 'bankaAdi', title: 'Banka', type: 'text', required: true, width: 130, max: 13 },
  { key: 'firma', title: 'Firma', type: 'entity', entity: 'firma', display: 'firma_adi', width: 150 },
  { key: 'sube', title: 'Şube', type: 'text', width: 120 },
  { key: 'hesap_no', title: 'Hesap No', type: 'text', width: 130 },
  { key: 'iban', title: 'IBAN', type: 'text', width: 220, max: 32 },
  { key: 'vadeli', title: 'Vade', type: 'select', width: 100, defaultValue: 0, options: [{ value: 0, label: 'Vadesiz' }, { value: 1, label: 'Vadeli' }] },
  { key: 'doviz', title: 'Döviz', type: 'doviz', defaultValue: 'TRY', width: 80 },
  { key: 'aciklama', title: 'Açıklama', type: 'textarea', inTable: false },
  { key: 'active', title: 'Durum', type: 'select', options: ACTIVE_OPTS, defaultValue: 1, width: 90 },
];
